import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useLocation } from "react-router-dom";
import { delete_icon, dummyimage } from "../../../assets/img";
import { deletes, get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../../screen/redux/api/PermissionManager";

const Receptionist = ({ setTabs }) => {
  const [receptionistOptions, setReceptionistOptions] = useState([]);
  const [selectedReceptionists, setSelectedReceptionists] = useState([]);
  const [loader, setLoader] = useState(false);

  const location = useLocation();
  const [type, setType] = useState(location?.state?.type);
  const id = location?.state?.id;
  const owner_id = location?.state?.owner;

  /* ---------------------- GET PROPERTY RECEPTIONISTS ---------------------- */

  const getList = async () => {
    setLoader(true);

    let res = await get(URLS.PROPERTY_MASTER + id + "/receptionists/");

    setLoader(false);

    if (res?.status === "success") {
      let recep = res?.data?.map((item) => ({
        code: item?.code,
        value: item?.id,
        label: item?.name,
        id: item?.id,
        email: item?.email,
        gender: item?.gender,
        mobile: item?.mobile,
        whatsapp: item?.whatsapp_no,
        image: item?.image,
        name: item?.name,
        map_id: item?.prop_receptionist,
        send_invoice: item?.send_invoice || false,
      }));

      setSelectedReceptionists(recep);
    }
  };

  /* ---------------------- GET ALL RECEPTIONISTS ---------------------- */

  const getOverallList = async () => {
    setLoader(true);

    let res = await get(URLS.RECEPTIONIST_OVERALL + owner_id + "/");

    setLoader(false);

    if (res?.status === "success") {
      let recep = res?.data?.map((item) => ({
        code: item?.code,
        value: item?.id,
        label: item?.name,
        id: item?.id,
        email: item?.email,
        gender: item?.gender,
        mobile: item?.mobile,
        whatsapp: item?.whatsapp_no,
        image: item?.image,
        name: item?.name,
        send_invoice: false,
      }));

      setReceptionistOptions(recep);
    }
  };

  useEffect(() => {
    if (id) getList();
    if (owner_id) getOverallList();
  }, []);

  /* ---------------------- SELECT CHANGE ---------------------- */

  const handleChange = (selected) => {
    const updated =
      selected?.map((item) => ({
        ...item,
        send_invoice: item?.send_invoice || false,
      })) || [];

    setSelectedReceptionists(updated);
  };

  /* ---------------------- WHATSAPP CHECKBOX ---------------------- */

  const handleWhatsappChange = (id, checked) => {
    setSelectedReceptionists((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, send_invoice: checked } : item,
      ),
    );
  };

  /* ---------------------- REMOVE SELECTED ---------------------- */

  const handleRemove = (value) => {
    if (type === "edit") {
      setSelectedReceptionists((prev) =>
        prev.filter((item) => item.value !== value),
      );
    }
  };

  /* ---------------------- SUBMIT ---------------------- */

  const handleSubmit = async () => {
    let payload = {
      receptionists: selectedReceptionists.map((item) => ({
        id: item.id,
        send_invoice: item.send_invoice || false,
      })),
    };

    setLoader(true);

    let res = await post(
      URLS.PROPERTY_MASTER + id + "/receptionists/add/",
      payload,
    );

    setLoader(false);

    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  /* ---------------------- DELETE ---------------------- */

  const handleDelete = async (mapId) => {
    setLoader(true);

    let res = await deletes(
      URLS.PROPERTY_MASTER + mapId + "/receptionists/delete/",
    );

    setLoader(false);

    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  /* ---------------------- CUSTOM OPTION ---------------------- */

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{props.label}</span>

          <div>
            <span className="me-3 sec">ID: {props.data?.code}</span>

            <button
              style={{
                height: "16px",
                width: "16px",
                borderRadius: "50%",
                border: "2px solid #9A36E6",
                position: "relative",
              }}
            >
              {props.isSelected && (
                <span
                  style={{
                    height: "8px",
                    width: "8px",
                    backgroundColor: "#9A36E6",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                  }}
                />
              )}
            </button>
          </div>
        </div>
      </components.Option>
    );
  };

  return (
    <div className="p-3">
      {checkPermission("CAN-EDIT-OVERALL_PROPERTIES") && (
        <div className="d-flex ac-je">
          {type !== "edit" ? (
            <button onClick={() => setType("edit")} className="add-btn mt-3">
              Edit
            </button>
          ) : (
            <button onClick={() => setType("view")} className="add-btn mt-3">
              Cancel
            </button>
          )}
        </div>
      )}

      {/* SELECT */}

      <div className="mb-4" style={{ maxWidth: 395 }}>
        {/* <Select
          options={receptionistOptions}
          value={selectedReceptionists}
          onChange={handleChange}
          placeholder="Select Receptionist"
          isMulti
          isSearchable
          isDisabled={type !== "edit"}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{ Option: CustomOption }}
        /> */}
        <Select
          options={receptionistOptions}
          value={selectedReceptionists}
          onChange={handleChange}
          placeholder="Select Receptionist"
          isMulti
          isSearchable
          isDisabled={type !== "edit"}
          isClearable={false}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CustomOption,
          }}
          styles={{
            control: (base) => ({
              ...base,
              borderColor: "#ccc",
              minHeight: "40px",
            }),
          }}
        />

        {/* SELECTED LIST */}

        {selectedReceptionists.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {selectedReceptionists.map((person, ind) => (
              <div
                key={ind}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 10px",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  marginBottom: 6,
                }}
              >
                <span>{person.label}</span>

                <div>
                  <span className="me-3 sec">ID: {person.code}</span>

                  <button
                    onClick={() => handleRemove(person.value)}
                    style={{
                      height: 16,
                      width: 16,
                      borderRadius: "50%",
                      border: "2px solid #9A36E6",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        height: 8,
                        width: 8,
                        backgroundColor: "#9A36E6",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                      }}
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* RECEPTIONIST DETAILS */}

      {type == "edit" && (
        <div>
          {selectedReceptionists.map((item, index) => (
            <div className="row mb-4 mt-4" key={item?.id}>
              {/* Profile Image */}
              <div className="d-flex ac-jb">
                <div
                  style={{ display: "flex", alignItems: "center", gap: 24 }}
                  className="mb-4"
                >
                  <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                    Receptionist-{index + 1}
                  </p>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <input
                      type="checkbox"
                      checked={item.send_invoice}
                      onChange={(e) =>
                        handleWhatsappChange(item.id, e.target.checked)
                      }
                      style={{ width: 25, height: 25 }}
                    />
                    <p style={{ fontSize: 16 }}>Whatsapp Notification</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    handleDelete(item?.map_id);
                  }}
                  className="cust-btn"
                >
                  <img src={delete_icon} alt="" className="edit-btn" />
                </button>
              </div>

              <div className="d-flex flex-column col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Profile Image<span style={{ color: "red" }}>*</span>
                </p>
                <img
                  src={item.image ? item?.image : dummyimage}
                  style={{
                    width: "70px",
                    height: "70px",
                    objectFit: "cover",
                    borderRadius: "35px",
                    cursor: "pointer",
                  }}
                  alt="Receptionist"
                />
              </div>

              {/* Gender */}
              <div className="col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Gender<span style={{ color: "red" }}>*</span>
                </p>
                <select
                  name="gender"
                  className="form-controls"
                  value={item.gender}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              {/* Name */}
              <div className="col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Receptionist Name<span style={{ color: "red" }}>*</span>
                </p>
                <input
                  name="userName"
                  value={item.name}
                  className="form-controls"
                  placeholder="Enter Receptionist Name"
                />
              </div>

              {/* Email */}
              <div className="col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Email ID<span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="email"
                  name="email"
                  value={item.email}
                  className="form-controls"
                  placeholder="Enter Email id"
                />
              </div>

              {/* Mobile */}
              <div className="col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Contact Number<span style={{ color: "red" }}>*</span>
                </p>
                <input
                  value={item.mobile}
                  className="form-controls"
                  maxLength={10}
                  placeholder="Enter Contact Number"
                />
              </div>

              {/* WhatsApp */}
              <div className="col-md-6 mb-3">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                  Whatsapp Number<span style={{ color: "red" }}>*</span>
                </p>
                <input
                  value={item.whatsapp}
                  className="form-controls"
                  maxLength={10}
                  placeholder="Enter WhatsApp Number"
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {/* {type === "edit" &&
        selectedReceptionists.map((item, index) => (
          <div className="row mb-4 mt-4" key={item.id}>
            <div className="d-flex ac-jb">
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <p>Receptionist-{index + 1}</p>

                <input
                  type="checkbox"
                  checked={item.send_invoice}
                  onChange={(e) =>
                    handleWhatsappChange(item.id, e.target.checked)
                  }
                />

                <p>Whatsapp Notification</p>
              </div>

              <button
                onClick={() => handleDelete(item.map_id)}
                className="cust-btn"
              >
                <img src={delete_icon} alt="" className="edit-btn" />
              </button>
            </div>


            <div className="col-md-6 mb-3">
              <p>Profile Image</p>

              <img
                src={item.image || dummyimage}
                style={{
                  width: 70,
                  height: 70,
                  borderRadius: 35,
                  objectFit: "cover",
                }}
                alt=""
              />
            </div>


            <div className="col-md-6 mb-3">
              <p>Receptionist Name</p>

              <input value={item.name} className="form-controls" />
            </div>


            <div className="col-md-6 mb-3">
              <p>Email</p>

              <input value={item.email} className="form-controls" />
            </div>


            <div className="col-md-6 mb-3">
              <p>Contact Number</p>

              <input value={item.mobile} className="form-controls" />
            </div>


            <div className="col-md-6 mb-3">
              <p>Whatsapp Number</p>

              <input value={item.whatsapp} className="form-controls" />
            </div>
          </div>
        ))} */}

      {/* BUTTONS */}

      <div className="d-flex ac-jb mt-4">
        <button onClick={() => setTabs(2)} className="back-btn mt-3 w-30">
          Back
        </button>

        {type === "edit" && (
          <button onClick={handleSubmit} className="submit-btn w-10">
            Submit
          </button>
        )}
      </div>
    </div>
  );
};

export default Receptionist;
